import { render, staticRenderFns } from "./FSIoperationCockpitInbound.vue?vue&type=template&id=3cb84efd"
import script from "./FSIoperationCockpitInbound.vue?vue&type=script&lang=js"
export * from "./FSIoperationCockpitInbound.vue?vue&type=script&lang=js"
import style0 from "./FSIoperationCockpitInbound.vue?vue&type=style&index=0&id=3cb84efd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports